export default __webpack_public_path__ + "static/melted-ed1ba73294caa365b0fe8a78e51aa879.png";